// extracted by mini-css-extract-plugin
export default {"titleSection":"styles_titleSection__hj-lS","title":"styles_title__CwzGi","subtitle":"styles_subtitle__ZdnlD","cardSection":"styles_cardSection__v8VAq"};